/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchImportParameterNamesRequestDto,
  CreateParameterNameRequestDto,
  ListParameterNamesResponseDto,
  ParameterNameResponseDto,
  UpdateParameterNameRequestDto,
} from '../models/index';
import {
    BatchImportParameterNamesRequestDtoFromJSON,
    BatchImportParameterNamesRequestDtoToJSON,
    CreateParameterNameRequestDtoFromJSON,
    CreateParameterNameRequestDtoToJSON,
    ListParameterNamesResponseDtoFromJSON,
    ListParameterNamesResponseDtoToJSON,
    ParameterNameResponseDtoFromJSON,
    ParameterNameResponseDtoToJSON,
    UpdateParameterNameRequestDtoFromJSON,
    UpdateParameterNameRequestDtoToJSON,
} from '../models/index';

export interface ParameterNameControllerBatchImportRequest {
    batchImportParameterNamesRequestDto: BatchImportParameterNamesRequestDto;
}

export interface ParameterNameControllerCreateRequest {
    createParameterNameRequestDto: CreateParameterNameRequestDto;
}

export interface ParameterNameControllerDeleteRequest {
    id: string;
}

export interface ParameterNameControllerFindAllRequest {
    limit: number;
    page: number;
    q?: string;
}

export interface ParameterNameControllerFindByIdRequest {
    id: string;
}

export interface ParameterNameControllerUpdateRequest {
    id: string;
    updateParameterNameRequestDto: UpdateParameterNameRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseParameterNamesApi extends runtime.BaseAPI {

    /**
     */
    async parameterNameControllerBatchImportRaw(requestParameters: ParameterNameControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['batchImportParameterNamesRequestDto'] == null) {
            throw new runtime.RequiredError(
                'batchImportParameterNamesRequestDto',
                'Required parameter "batchImportParameterNamesRequestDto" was null or undefined when calling parameterNameControllerBatchImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/parameter-names/batch-import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchImportParameterNamesRequestDtoToJSON(requestParameters['batchImportParameterNamesRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async parameterNameControllerBatchImport(requestParameters: ParameterNameControllerBatchImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.parameterNameControllerBatchImportRaw(requestParameters, initOverrides);
    }

    /**
     */
    async parameterNameControllerCreateRaw(requestParameters: ParameterNameControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParameterNameResponseDto>> {
        if (requestParameters['createParameterNameRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createParameterNameRequestDto',
                'Required parameter "createParameterNameRequestDto" was null or undefined when calling parameterNameControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/parameter-names`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateParameterNameRequestDtoToJSON(requestParameters['createParameterNameRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParameterNameResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async parameterNameControllerCreate(requestParameters: ParameterNameControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParameterNameResponseDto> {
        const response = await this.parameterNameControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async parameterNameControllerDeleteRaw(requestParameters: ParameterNameControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parameterNameControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/parameter-names/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async parameterNameControllerDelete(requestParameters: ParameterNameControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.parameterNameControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async parameterNameControllerFindAllRaw(requestParameters: ParameterNameControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListParameterNamesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling parameterNameControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling parameterNameControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/parameter-names`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListParameterNamesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async parameterNameControllerFindAll(requestParameters: ParameterNameControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListParameterNamesResponseDto> {
        const response = await this.parameterNameControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async parameterNameControllerFindByIdRaw(requestParameters: ParameterNameControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParameterNameResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parameterNameControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/parameter-names/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParameterNameResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async parameterNameControllerFindById(requestParameters: ParameterNameControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParameterNameResponseDto> {
        const response = await this.parameterNameControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async parameterNameControllerUpdateRaw(requestParameters: ParameterNameControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParameterNameResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parameterNameControllerUpdate().'
            );
        }

        if (requestParameters['updateParameterNameRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateParameterNameRequestDto',
                'Required parameter "updateParameterNameRequestDto" was null or undefined when calling parameterNameControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/parameter-names/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateParameterNameRequestDtoToJSON(requestParameters['updateParameterNameRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParameterNameResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async parameterNameControllerUpdate(requestParameters: ParameterNameControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParameterNameResponseDto> {
        const response = await this.parameterNameControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
